import { Box, Button, Link, Typography } from '@freighthub/silhouette-core'
import { observer } from 'mobx-react'
import { Component, CSSProperties } from 'react'
import { I18N } from 'utils/localisation'

import { ActivityFeedIcon } from '../ActivityFeedIcon'
import { CollapseTable } from './CollapseTable'
import {
  COLLAPSE_TABLE,
  DOWNLOAD,
  IActivityMessageSection,
  ICON,
  LABELED,
  TEXT,
  UPDATE_TABLE,
} from './MessageSectionType'
import { UpdateTable } from './UpdateTable'

const styles: { [key: string]: CSSProperties } = {
  messageContent: {
    wordWrap: 'break-word',
    whiteSpace: 'pre-line',
    hyphens: 'auto',
  },
}

interface IMsgSectionProps {
  handleDownload: (doc: { _id: string; name: string }) => void
  section: IActivityMessageSection
}
@observer
export class MsgSection extends Component<IMsgSectionProps> {
  render() {
    const { handleDownload, section } = this.props
    const sectionContent = section.contentNode || section.content

    if (section.hide === true) {
      return null
    }

    switch (section.type) {
      case DOWNLOAD:
        return (
          <DownloadSection _id={section._id!} handleDownload={handleDownload} section={section} name={section.name!} />
        )
      case TEXT: {
        const content = section.translate ? (
          <I18N term={section.content!} params={section.translationParams} />
        ) : (
          sectionContent
        )
        return (
          <Typography
            variant={section.variant || 'body2'}
            color="textSecondary"
            sx={(theme) => ({
              ...styles.messageContent,
              ...(section.getStyle ? section.getStyle(theme) : section.style),
            })}
            component="span"
          >
            {content}
          </Typography>
        )
      }
      case ICON: {
        const { style = {}, getStyle } = section
        return (
          <Box sx={getStyle ? (theme) => getStyle(theme) : style}>
            <ActivityFeedIcon iconType={section.content!} style={{ width: '100%', height: '100%' }} />
          </Box>
        )
      }
      case UPDATE_TABLE:
        return <UpdateTable content={section.tableContent!} style={section.style} />
      case COLLAPSE_TABLE:
        return <CollapseTable content={section.tableContent!} />
      case LABELED:
        return (
          <Typography
            variant={section.variant || 'body2'}
            color="textSecondary"
            component="span"
            sx={(theme) => (section.getStyle ? section.getStyle(theme) : {})}
            style={{ ...styles.messageContent, ...section.style }}
          >
            {section.translate ? <I18N term={section.label!} /> : section.label}
            {section.label && <span>: </span>}
            {section.url && section.linkText && (
              <Link to={section.url}>
                <b>{section.linkText}</b>
              </Link>
            )}
            {sectionContent && <span>{sectionContent}</span>}
          </Typography>
        )
      default:
        return null
    }
  }
}

interface IDownloadSectionProps {
  handleDownload: (doc: { _id: string; name: string }) => void
  _id: string
  name: string
  section: IActivityMessageSection
}

class DownloadSection extends Component<IDownloadSectionProps> {
  handleClick = () => {
    const { _id, handleDownload, name } = this.props
    handleDownload({ _id, name })
  }
  render() {
    const {
      section: { content, translate, translationParams },
    } = this.props
    return (
      <Button onClick={this.handleClick} size="small">
        {translate ? <I18N term={content!} params={translationParams} /> : content}
      </Button>
    )
  }
}
